import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-70597d40"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "head-back"
};
const _hoisted_3 = {
  class: "head-width"
};
const _hoisted_4 = ["src"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "提现", -1));

const _hoisted_6 = {
  class: "head-width at-right"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("提现记录");

const _hoisted_8 = {
  class: "price-back"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "现金奖励", -1));

const _hoisted_10 = {
  class: "price-main"
};
const _hoisted_11 = {
  class: "big-price"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元", -1));

const _hoisted_13 = {
  class: "input-back"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "input-name"
}, "支付宝账号", -1));

const _hoisted_15 = {
  class: "input-back"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "input-name"
}, "姓名", -1));

const _hoisted_17 = {
  class: "cash-btn-back"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cash-tips"
}, "提现说明", -1));

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cash-tips-content"
}, [/*#__PURE__*/_createTextVNode(" 1.由于支付宝提现需要账号及真实姓名，如填写错误可能导致提现失败，请确保填写内容真实无误"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 2.请确保支付宝开启账号隐私设置，需要通过搜索账号发放奖励"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 3.提现申请将在3个工作日内审核，审核通过后即发放奖励"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 4.每年1月1日更新数据库，所有未提现金额将清零，请及时提现"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 5.针对违规骗取邀请奖励的行为，将不予发放邀请奖励、追回相关奖励、封停账号"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 6.必须确保用户资料真实，比如女性用户提现，不能提到男性用户支付宝，如果出现资料不符的情况，将扣除全部奖励"), /*#__PURE__*/_createElementVNode("br")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $setup.Back,
    class: "back-head",
    onClick: _cache[0] || (_cache[0] = $event => $setup.router.back())
  }, null, 8, _hoisted_4)]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_router_link, {
    to: {
      name: 'CashRecord'
    },
    class: "to-record"
  }, {
    default: _withCtx(() => [_hoisted_7]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString($setup.info.money), 1), _hoisted_12])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _withDirectives(_createElementVNode("input", {
    type: "text",
    dir: "rtl",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.param.account = $event),
    class: "account"
  }, null, 512), [[_vModelText, $setup.param.account]])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _withDirectives(_createElementVNode("input", {
    type: "text",
    dir: "rtl",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.param.name = $event),
    class: "account"
  }, null, 512), [[_vModelText, $setup.param.name]])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
    class: "cash-btn",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.cash && $setup.cash(...args))
  }, "立即提现")]), _hoisted_18, _hoisted_19]);
}